module.exports = __webpack_public_path__ + "img/gleam_tab.f316c81.webp";